export default __webpack_public_path__ + "static/media/patient.556d0897.svg";